export const buttons = {
    back: "Back",
    next: "Next",
    submit: "Proceed to Payment"
}